import React from "react";
import { RefreshCcw } from "lucide-react";

import { Button } from "../ui/button";

interface LoginRequiredStateProps {
  onSignIn: () => void;
}

export function LoginRequiredState({ onSignIn }: LoginRequiredStateProps) {
  return (
    <div className="text-center py-16 space-y-3">
      <p className="text-lg font-medium text-slate-700 dark:text-slate-200">
        Sign in to view your liked content.
      </p>
      <p className="text-sm text-slate-500 dark:text-slate-400">
        Articles and quotes you've liked will show up here.
      </p>
      <Button onClick={onSignIn} className="mt-2">
        Sign In
      </Button>
    </div>
  );
}

interface LikedErrorStateProps {
  onRetry: () => void;
}

export function LikedErrorState({ onRetry }: LikedErrorStateProps) {
  return (
    <div className="text-center py-16 space-y-3">
      <RefreshCcw className="w-8 h-8 mx-auto text-slate-400" aria-hidden="true" />
      <p className="text-lg font-medium text-slate-700 dark:text-slate-200">
        We couldn't load your likes.
      </p>
      <p className="text-sm text-slate-500 dark:text-slate-400">Please try again.</p>
      <Button onClick={onRetry} variant="outline" className="mt-2">
        Try Again
      </Button>
    </div>
  );
}
